import styled from "@yb/styled-px2rem";

const Wrap = styled.div`
	position: relative;
	width: 100%;
	table {
		border-top: none;
		border-collapse: separate;
		border-spacing: 0;
		th {
			text-align: center;
		}
		td {
			vertical-align: baseline;
			word-break: break-all;
			+ td {
				border-left: 1px solid var(--line-color);
			}
		}
		tr {
			&:last-child td {
				background-color: var(--disabled-color);
			}
		}
	}
`;

const FixedArea = styled.tr`
	position: sticky;
	z-index: 10;
	width: 100%;
	height: auto;
	background-color: #fff;
	&:first-of-type {
		top: 60px;
		> th {
			border-top: 1px solid #000;
			border-bottom: 1px solid var(--line-color);
		}
	}
	&:nth-of-type(2) {
		top: 115px;
		border-bottom: 1px solid var(--line-color);
	}
`;

const Tag = styled.div`
	display: block;
`;

const PriceList = styled.ul`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;
const PriceListItem = styled.li`
	display: flex;
	flex-direction: column;
	gap: 5px;
`;
const Price = styled.span`
	display: flex;
	flex-wrap: wrap;
	gap: 0 5px;
	em {
		font-size: 18px;
		font-weight: bold;
		color: var(--emp-color);
	}
`;
const BtnBlock = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	padding: 15px 0;

	button {
		width: 70%;
	}
`;

export {Wrap, Tag, PriceList, PriceListItem, Price, BtnBlock, FixedArea};
